import { baseUrl, environment } from "../environment";
import {
  CreateRolePayload,
  GetRoleByIDPayload,
  LifeCycleCreatePayload,
  RoleAssignToUserPayload,
  UpdateRolePayload,
  UserLifecyclePayload,
  UserRoleMappingPayload,
} from "../models/userManagementModel";
import RestService from "./rest";

export const serviceClient = new RestService({
  baseURL: baseUrl,
});

export const GetAllAccessControlMasterService = () => {
  return serviceClient.get(environment.urls.getAllAccessControl);
};
export const CreateRoleService = (data: CreateRolePayload) => {
  return serviceClient.post(environment.urls.createRole, data);
};
export const GetAllRoleMasterListService = (params?: any) => {
  return serviceClient.get(environment.urls.getAllRoleMasterList, { params });
};

export const GetRoleByIDService = (data: GetRoleByIDPayload) => {
  return serviceClient.post(environment.urls.getRoleByID, data);
};
export const UpdateRoleService = (data: UpdateRolePayload) => {
  return serviceClient.post(environment.urls.updateRole, data);
};
export const UserRoleMappingService = (data: UserRoleMappingPayload) => {
  return serviceClient.post(environment.urls.userRoleMapping, data);
};
export const RoleAssignToUserService = (data: RoleAssignToUserPayload) => {
  return serviceClient.post(environment.urls.roleAssignToUser, data);
};

export const GetAllUserByOrganizationListService = (
  data: UserLifecyclePayload
) => {
  return serviceClient.post(environment.urls.getAllUsersByOrganization, data);
};

export const createUserLifecycleService = (data: LifeCycleCreatePayload) => {
  return serviceClient.post(environment.urls.createLifeCycle, data);
};
